import React, { useState } from 'react';
import API from '../api';
import './MerchantAccountModal.css';

const MerchantAccountModal = ({ isOpen, onClose, onSuccess, sellerId, isSeller = false, sellerInfo = null }) => {
  const [createStep, setCreateStep] = useState(1);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');
  const [merchantForm, setMerchantForm] = useState({
    merchant_name: sellerInfo?.store_name || sellerInfo?.business_name || '',
    website_url: sellerInfo?.website || '',
    business_name: sellerInfo?.business_name || '',
    phone_number: sellerInfo?.phone_number || '',
    address_street: sellerInfo?.address || '',
    address_city: sellerInfo?.city || '',
    address_province: sellerInfo?.province || '',
    address_zip: sellerInfo?.zip || '',
    address_country: sellerInfo?.country || 'IT',
    customer_service_url: sellerInfo?.website || '',
    customer_service_email: '',
    customer_service_phone: sellerInfo?.phone_number || '',
    country: sellerInfo?.country || 'IT',
    currency: 'EUR',
    language: 'it'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMerchantForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCreateMerchant = async () => {
    try {
      setProcessing(true);
      setError('');

      const endpoint = isSeller ? '/google-shopping/merchant/create-seller' : '/google-shopping/merchant/create';
      const payload = isSeller ? merchantForm : { ...merchantForm, seller_id: sellerId };
      
      const response = await API.post(endpoint, payload);

      if (response.data.success) {
        onSuccess(response.data.merchant);
        onClose();
        setCreateStep(1);
        setMerchantForm({
          merchant_name: sellerInfo?.store_name || sellerInfo?.business_name || '',
          website_url: sellerInfo?.website || '',
          business_name: sellerInfo?.business_name || '',
          phone_number: sellerInfo?.phone_number || '',
          address_street: sellerInfo?.address || '',
          address_city: sellerInfo?.city || '',
          address_province: sellerInfo?.province || '',
          address_zip: sellerInfo?.zip || '',
          address_country: sellerInfo?.country || 'IT',
          customer_service_url: sellerInfo?.website || '',
          customer_service_email: '',
          customer_service_phone: sellerInfo?.phone_number || '',
          country: sellerInfo?.country || 'IT',
          currency: 'EUR',
          language: 'it'
        });
      }
    } catch (error) {
      console.error('Errore nella creazione merchant account:', error);
      setError(error.response?.data?.message || 'Errore nella creazione del merchant account');
    } finally {
      setProcessing(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content merchant-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Configura Merchant Account CSS</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {createStep === 1 ? (
            <div className="form-step">
              <h3>Informazioni Base</h3>
              <div className="form-group">
                <label htmlFor="merchant_name">Nome Merchant *</label>
                <input
                  type="text"
                  id="merchant_name"
                  name="merchant_name"
                  value={merchantForm.merchant_name}
                  onChange={handleInputChange}
                  placeholder="Nome del tuo negozio"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="website_url">URL Sito Web *</label>
                <input
                  type="url"
                  id="website_url"
                  name="website_url"
                  value={merchantForm.website_url}
                  onChange={handleInputChange}
                  placeholder="https://tuosito.com"
                  required
                />
              </div>


            </div>
          ) : (
            <div className="form-step">
              <h3>Informazioni Aziendali</h3>
              
              <div className="form-group">
                <label htmlFor="business_name">Ragione Sociale *</label>
                <input
                  type="text"
                  id="business_name"
                  name="business_name"
                  value={merchantForm.business_name}
                  onChange={handleInputChange}
                  placeholder="Nome della tua azienda"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone_number">Telefono *</label>
                <input
                  type="tel"
                  id="phone_number"
                  name="phone_number"
                  value={merchantForm.phone_number}
                  onChange={handleInputChange}
                  placeholder="+39 123 456 7890"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="address_street">Indirizzo *</label>
                <input
                  type="text"
                  id="address_street"
                  name="address_street"
                  value={merchantForm.address_street}
                  onChange={handleInputChange}
                  placeholder="Via Roma 123"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="address_city">Città *</label>
                  <input
                    type="text"
                    id="address_city"
                    name="address_city"
                    value={merchantForm.address_city}
                    onChange={handleInputChange}
                    placeholder="Milano"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="address_province">Provincia *</label>
                  <input
                    type="text"
                    id="address_province"
                    name="address_province"
                    value={merchantForm.address_province}
                    onChange={handleInputChange}
                    placeholder="MI"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="address_zip">CAP *</label>
                  <input
                    type="text"
                    id="address_zip"
                    name="address_zip"
                    value={merchantForm.address_zip}
                    onChange={handleInputChange}
                    placeholder="20100"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="address_country">Paese *</label>
                  <select
                    id="address_country"
                    name="address_country"
                    value={merchantForm.address_country}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="IT">Italia</option>
                    <option value="US">Stati Uniti</option>
                    <option value="DE">Germania</option>
                    <option value="FR">Francia</option>
                    <option value="ES">Spagna</option>
                  </select>
                </div>
              </div>

              <h4>Servizio Clienti (Opzionale)</h4>
              
              <div className="form-group">
                <label htmlFor="customer_service_url">URL Servizio Clienti</label>
                <input
                  type="url"
                  id="customer_service_url"
                  name="customer_service_url"
                  value={merchantForm.customer_service_url}
                  onChange={handleInputChange}
                  placeholder="https://support.tuosito.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="customer_service_email">Email Servizio Clienti</label>
                <input
                  type="email"
                  id="customer_service_email"
                  name="customer_service_email"
                  value={merchantForm.customer_service_email}
                  onChange={handleInputChange}
                  placeholder="support@tuosito.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="customer_service_phone">Telefono Servizio Clienti</label>
                <input
                  type="tel"
                  id="customer_service_phone"
                  name="customer_service_phone"
                  value={merchantForm.customer_service_phone}
                  onChange={handleInputChange}
                  placeholder="+39 123 456 7890"
                />
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          {createStep === 1 ? (
            <>
              <button 
                className="btn btn-secondary"
                onClick={onClose}
              >
                Annulla
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => setCreateStep(2)}
                disabled={!merchantForm.merchant_name || !merchantForm.website_url}
              >
                Avanti
              </button>
            </>
          ) : (
            <>
              <button 
                className="btn btn-secondary"
                onClick={() => setCreateStep(1)}
              >
                Indietro
              </button>
              <button 
                className="btn btn-primary"
                onClick={handleCreateMerchant}
                disabled={processing || !merchantForm.business_name || !merchantForm.phone_number || !merchantForm.address_street || !merchantForm.address_city || !merchantForm.address_province || !merchantForm.address_zip}
              >
                {processing ? 'Creazione in corso...' : 'Crea Merchant Account'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MerchantAccountModal; 